import { render, staticRenderFns } from "./tacs_sso_callback.vue?vue&type=template&id=a1937e2a&scoped=true&"
import script from "./tacs_sso_callback.vue?vue&type=script&lang=js&"
export * from "./tacs_sso_callback.vue?vue&type=script&lang=js&"
import style0 from "./tacs_sso_callback.vue?vue&type=style&index=0&id=a1937e2a&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1937e2a",
  null
  
)

export default component.exports